<template>
  <div>
    <div class="dialog__background"></div>
    <div class="alert__dialog">
      <div class="dialog__close" @click="handleClose"></div>
      <div class="dialog__title">{{ presaleStatus.title }}</div>
      <div class="dialog__content__container">
        <div class="dialog__content">{{ presaleStatus.msg }}</div>
      </div>
      <div class="dialog__button" v-if="Number(presaleStatus.status) === 5">
        <div class="dialog__cancle" @click="handlePreSale($event)">
          {{ presaleStatus.description }}
        </div>
        <div class="dialog__handle" @click="handleApply($event)">报名此课</div>
      </div>
      <div class="dialog__button" v-else>
        <div class="dialog__cancle" @click="handleClose">取消</div>
        <div class="dialog__handle" @click="handlePreSale($event)">
          {{ presaleStatus.description }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '@/modules/dialog-builder/mixin'

export default {
  popupConfig: {
    modal: false
  },
  mixins: [mixin],
  methods: {
    handleClose() {
      this.resolve()
    },
    handleApply(event) {
      window.location.href = `https://trade.xueersi.com/Web/Order/confirm?idEncode=${this.presaleStatus.idEncode}`
      this.xesLog(
        'click',
        {
          type: 'xeslog-continueBuy-enroll',
          clickId: '1.3.46',
          clickUrl: `https://trade.xueersi.com/Web/Order/confirm?idEncode=${this.presaleStatus.idEncode}`
        },
        event
      )
    },
    handlePreSale(event) {
      window.location.href = this.presaleStatus.url
      let params = {}
      // console.log(this.presaleStatus.status)
      switch (this.presaleStatus.status) {
        case 2:
          params = {
            type: 'xeslog-alreadyOrder-check',
            clickId: '1.3.41',
            clickUrl: this.presaleStatus.url
          }
          break
        case 3:
          params = {
            type: 'xeslog-alreadyOrder-payFinal',
            clickId: '1.3.42',
            clickUrl: this.presaleStatus.url
          }
          break
        case 4:
          params = {
            type: 'xeslog-alreadyBuy-check',
            clickId: '1.3.43',
            clickUrl: this.presaleStatus.url
          }
          break
        case 5:
          params = {
            type: 'xeslog-continueBuy-studyCenter',
            clickId: '1.3.47',
            clickUrl: this.presaleStatus.url
          }
          break
        case 9:
          params = {
            type: 'xeslog-commonBuy-detail',
            clickId: '1.3.49',
            clickUrl: this.presaleStatus.url
          }
          break
        default:
          return false
      }
      this.xesLog('click', params, event)
    }
  }
}
</script>

<style scoped lang="scss">
.dialog__background {
  display: block;
  width: 100%;
  height: 100%;
  opacity: 0.7;
  position: fixed;
  background: #000000;
  top: 0;
  left: 0;
  z-index: 2000;
}
.alert__dialog {
  width: 446px;
  // height: 234px;
  background: #ffffff;
  border-radius: 2px;
  top: 45%;
  left: 40%;
  line-height: 25px;
  position: fixed;
  z-index: 2001;
  .dialog__close {
    width: 14px;
    height: 14px;
    position: absolute;
    top: 20px;
    right: 20px;
    background-image: url('~@/views/CourseDetail/images/close-btn-gray.png');
    background-size: cover;
    background-repeat: no-repeat;
    cursor: pointer;
  }
  .dialog__title {
    font-weight: 600;
    margin-top: 66px;
    text-align: center;
    color: #333333;
    font-size: 16px;
  }
  .dialog__content__container {
    text-align: center;
    .dialog__content {
      text-align: left;
      display: inline-block;
      margin-top: 20px;
      color: #666666;
      font-size: 14px;
      line-height: 22px;
      padding: 0 30px 0 30px;
    }
  }
  .dialog__button {
    margin-left: 81px;
    font-size: 14px;
    margin-top: 56px;
    margin-bottom: 32px;
    & > div {
      width: 130px;
      height: 40px;
      text-align: center;
      line-height: 40px;
    }
    .dialog__cancle {
      display: inline-block;
      border: 1px #dedede solid;
      border-radius: 2px;
      cursor: pointer;
    }
    .dialog__handle {
      margin-left: 24px;
      display: inline-block;
      color: #ffffff;
      background: #f13232;
      border-radius: 2px;
      cursor: pointer;
    }
  }
}
.alert__dialog__toast {
  position: fixed;
  z-index: 2000;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.5s;
  text-align: center;
  border-radius: 5px;
  color: #fff;
  background: rgba(17, 17, 17, 0.7);
  font-size: 16px;
  height: 48px;
  line-height: 48px;
  padding: 0 15px;
}
.btn-loading {
  position: relative;
  height: 40px;
  width: 280px;
  background: #f13232;
  border-radius: 2px;
  color: #ffffff;
  margin: 0 20px;
  font-size: 18px;
  line-height: 40px;
  text-align: center;
}
.spinner-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.5, 0.5);
}
</style>



// WEBPACK FOOTER //
// ./src/views/CourseDetail/components/DetailAlertDailog.vue